import { useEffect } from "react";
import Heading from "@/components/tpr/Heading/Heading";
import { BreadcrumbItem, BreadcrumbLink } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { useBreadcrumb } from "@/contexts/breadcrumbContext";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";

const AllMyBookingsView = () => {
  const { setBreadcrumb } = useBreadcrumb();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <>
        <BreadcrumbItem className="text-sm text-gray-600 truncate max-w-[125px] md:max-w-none">
          <BreadcrumbLink href="#">My Bookings</BreadcrumbLink>
        </BreadcrumbItem>
      </>,
    );
    return () => setBreadcrumb(null);
  }, [setBreadcrumb]);

  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`My Bookings`} />
        </div>
        <div className="mb-2 bg-gray-100 p-2 rounded-md w-full flex justify-between">
          <Button variant="link" onClick={() => navigate(-1)} aria-label="Back" className="hover:cursor-pointer">
            <ChevronLeft /> Back
          </Button>
        </div>

        <div className="flex flex-col gap-2">yyy</div>
      </div>
    </div>
  );
};

export default AllMyBookingsView;
